import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import {
  generateOptions,
  tempToColor,
  timestampConverter,
} from "../utils/helpers";
import { useState } from "react";
function HourlyForecastChart({ tempColor, hourly }) {
  const [option, setOption] = useState("temp");
  if (hourly === undefined) return;
  const { key, name, unit, color } = generateOptions(option);
  const newHourly = hourly.map((item) => {
    const newItem = { ...item, label: timestampConverter(item.dt) };
    return newItem;
  });
  return (
    <div
      style={{
        width: "90%",
        margin: "auto",
        transition: ".5s",
        backgroundColor: `${tempToColor(tempColor)}`,
        padding: "20px",
        borderRadius: "20px",
      }}
    >
      <h3>48 Hour Forecast</h3>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={newHourly}>
          <XAxis dataKey="label"></XAxis>
          <YAxis></YAxis>
          <CartesianGrid strokeDasharray="4"></CartesianGrid>
          <Tooltip></Tooltip>
          <Area
            type="monotone"
            fill={color}
            dataKey={key}
            strokeWidth={2}
            name={`${name} (day)`}
            unit={unit}
          ></Area>
        </AreaChart>
      </ResponsiveContainer>
      <form>
        <label>
          forecast by
          <select value={option} onChange={(e) => setOption(e.target.value)}>
            <option value="temp">temperature(celsius)</option>
            <option value="clouds">cloudiness(%)</option>
            <option value="humidity">humidity(%)</option>
            <option value="pressure">pressure(hPa)</option>
            <option value="visibility">visibility(meters)</option>
          </select>
        </label>
      </form>
    </div>
  );
}

export default HourlyForecastChart;
